export default function initProjectFilters() {
    const projectFilters = document.querySelectorAll(".project-filters__item");
    const projects = document.querySelectorAll(".project");
    if (!projectFilters.length || !projects.length)
        return;
    let activeFilters = [];
    const filterProjects = (item, event) => {
        const applyFilter = () => {
            const termID = parseInt(item.dataset.termId);
            activeFilters.includes(termID)
                ? activeFilters.splice(activeFilters.indexOf(termID))
                : activeFilters.push(termID);
            item.classList.toggle("active");
            projects.forEach((project) => {
                if (!activeFilters.length) {
                    project.classList.remove("hidden");
                    return;
                }
                const terms = project.dataset.terms;
                const parsedTerms = JSON.parse(terms);
                project.classList.toggle("hidden", !activeFilters.some((termID) => {
                    return parsedTerms.includes(termID);
                }));
            });
            console.log(activeFilters);
        };
        if (document.startViewTransition) {
            document.startViewTransition(applyFilter);
        }
        else {
            applyFilter();
        }
    };
    projectFilters.forEach((filter) => {
        filter.addEventListener("click", filterProjects.bind(null, filter));
    });
}
